import script from "./startup-applications.vue?vue&type=script&setup=true&lang=js"
export * from "./startup-applications.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__